export default {
  namespaced: true,
  state: {
    isShown: false,
  },
  mutations: {
    SET_IS_SHOWN: (state, val) => { state.isShown = val; },
  },
};
